import { render, staticRenderFns } from "./ShopeeToSellerModal.vue?vue&type=template&id=4fb32fc5&"
import script from "./ShopeeToSellerModal.vue?vue&type=script&lang=js&"
export * from "./ShopeeToSellerModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeToSellerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports